import 'ui-theme/js/widgets/_slideshow';

let slider = UX.slider;

slider.set.responsive = function () {
    let key;
    slider.responsive = slider.get.responsiveData();
    if (slider.responsive) {
        for (key in slider.responsive) {
            switch (key) {
                case 'xsMin':
                    slider.responsive[0] = slider.responsive[key];
                    break;
                case 'smMin':
                    slider.responsive[UX.grid.screenXsMax] = slider.responsive[key];
                    delete slider.responsive[key];
                    break;
                case 'mdMin':
                    slider.responsive[UX.grid.screenSmMax] = slider.responsive[key];
                    break;
                case 'lgMin':
                    slider.responsive[UX.grid.screenMdMax] = slider.responsive[key];
                    break;
                case 'xlgMin':
                    slider.responsive[UX.grid.screenLgMax] = slider.responsive[key];
                    break;
                case 'xxlgMin':
                    slider.responsive[UX.grid.screenXlgMax] = slider.responsive[key];
                    break;
            }
        }
    }
};

UX.slider = slider;
